module.exports = __webpack_public_path__ + "static/media/Poppins-Medium.507ef5cd.woff";